export const SECTIONS = {
  messenger: { key: "messenger", prefix: "/messenger", title: "BAFD Messenger" },
  records: { key: "records", prefix: "/records", title: "BAFD RMS — Bonduel Area Fire Department" },
  ics: { key: "ics", prefix: "/command", title: "ICS Command Hub | Incident Command System" },
  training: { key: "training", prefix: "/training", title: "BAFD Training" },
  ppe: { key: "ppe", prefix: "/turnout", title: "BAFD Turnout Tracker" },
  access: { key: "access", prefix: "/access", title: "BAFD Section Access" },
  bafd: { key: "bafd", prefix: "", title: null },
};

export function sectionForPath(pathname) {
  const match = Object.values(SECTIONS).find(
    (s) => s.prefix && (pathname === s.prefix || pathname.startsWith(`${s.prefix}/`)),
  );
  return match || SECTIONS.bafd;
}
